import React from 'react'
import ReactDOM from 'react-dom'
import {localsMessages} from '../utility/getTemplateData'

let messages = localsMessages('common/orLine')
let PropTypes = React.PropTypes

export default React.createClass({

    propTypes:{
        name: React.PropTypes.string,
        label: React.PropTypes.string,
        value: React.PropTypes.string
    },

    getInitialState () {
        return {};
    },

    render () {

        let orLabel = messages.label && messages.label.or

        return (
        	<div className="donate_or_linner center-block">
                <div className="donate_inline">
                  <p className="or_line"></p>
                </div>
                <div className="donate_inline center_or">
                  <span className="donate_or_text" id="OrLineTxt">{orLabel}</span>
                </div>
                <div className="donate_inline"><p className="or_line"></p></div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./common/orLine.js